import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { MyProperty, Portfolio } from './portfolio.model';
import { dummyDataMyProperties } from '@shared/dummyData/my-properties.data';
import { COLLECTION, db } from '@shared/helpers/database';

@Injectable({
  providedIn: 'root',
})
export class PortfolioService {
  readonly portfolio$: Observable<Portfolio | null>;
  readonly myProperties$: Observable<MyProperty[]>;
  readonly isPortofolioLoading$: Observable<boolean>;
  readonly isMyPropertiesLoading$: Observable<boolean>;

  private readonly _portfolio$: BehaviorSubject<Portfolio | null> =
    new BehaviorSubject<Portfolio | null>(null);
  protected readonly _myProperties$: BehaviorSubject<MyProperty[]> =
    new BehaviorSubject<MyProperty[]>([]);
  private readonly _isPortofolioLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject(false);
  private readonly _isMyPropertiesLoading$: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor() {
    this.portfolio$ = this._portfolio$.asObservable();
    this.myProperties$ = this._myProperties$.asObservable();
    this.isPortofolioLoading$ = this._isPortofolioLoading$.asObservable();
    this.isMyPropertiesLoading$ = this._isMyPropertiesLoading$.asObservable();
  }

  getPortfolio(): void {
    this._isPortofolioLoading$.next(true);

    db[COLLECTION.PORTFOLIO].list().then((res: { documents: any }) => {
      this._portfolio$.next(res.documents[0]);
      this._isPortofolioLoading$.next(false);
      console.log(res);
    });

    // const portfolio: Portfolio = {
    //   totalValue: 12353,
    //   growthOverviewChartDates: [
    //     new Date('2024-11-01'),
    //     new Date('2024-12-10'),
    //     new Date('2024-12-30'),
    //     new Date('2025-01-05'),
    //     new Date('2025-02-25'),
    //     new Date('2025-03-01'),
    //     new Date('2025-03-31'),
    //   ],
    //   growthOverviewChartValues: [0, 505, 3756, 5890, 6501, 8302, 12353],
    //   monthlyIncome: 424,
    //   totalRentalIncome: 5123,
    //   totalAppreciation: 12,
    //   financialPeriod: new Date('2025-02-01'),
    //   numberOfInvestedProperties: 8,
    //   occupancyRate: 100,
    //   annualRentalYield: 9.7,
    // };
    // setTimeout(() => {
    //   this._portfolio$.next(portfolio);
    //   this._isPortofolioLoading$.next(false);
    // }, 200);
  }

  getMyProperties(): void {
    this._isMyPropertiesLoading$.next(true);

    db[COLLECTION.MY_PROPERTIES].list().then((res: { documents: any }) => {
      this._myProperties$.next(res.documents);
      this._isMyPropertiesLoading$.next(false);
      console.log(res);
    });

    // const myProperties: MyProperty[] = [...dummyDataMyProperties];
    // setTimeout(() => {
    //   this._myProperties$.next(myProperties);
    //   this._isMyPropertiesLoading$.next(false);
    // }, 500);
  }
}
